<template>
    <div class="users-style">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Leave Approver Settings</span>
        </h4>

        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Leave Approver Settings</h4>
                </div>
                <div class="ibox-content px-0 pt-4">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent>
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-form-checkbox v-model="fdata.status" name="check-button" class="pt-2" :value="1" :unchecked-value="0" switch>
                                        Enable Leave Approver
                                    </b-form-checkbox>
                                </div>
                                <div class="col-sm-6 mt-3">
                                    <b-form-group id="leave_approver_type-group" label="Leave Approval Process" class="required-field" label-for="leave_approver_type">
                                        <b-form-select id="leave_approver_type" name="leave_approver_type" v-model="fdata.approver_type" :options="approver_types"></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="btn-wrapper pt-5">
                                <b-button class="btn-primary" variant="primary" @click="setSettings">Submit</b-button>
                            </div>
                        </b-form>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>
<!-- <template>
  <b-card>
    <b-card-body>
      <div style="display: inline;">
        <b-form-checkbox v-model="fdata.status" name="check-button" :value="1" :unchecked-value="0" switch>
          Enable Leave Approver
        </b-form-checkbox>

        <b-form-group  id="leave_approver_type-group" label="Leave Approval Process" class="required-field mt-2" label-for="leave_approver_type">
          <b-form-select id="leave_approver_type" name="leave_approver_type" v-model="fdata.approver_type" :options="approver_types" ></b-form-select>
        </b-form-group>

        <b-button @click="setSettings">Save</b-button>
      </div>
    </b-card-body>
  </b-card>
</template> -->

<script>
export default {
  data(){
    return {
        showoverlay: false,
        approver_types:[{
            value: 'sequential',
            text: 'Sequential Approval',
        },{
            value: 'anyone',
            text: 'Any-one Approval',
        },],
        fdata: {
            status: 0,
            approver_type: 'sequential',
        }
    }
  },
  methods:{
    getSettings(){
      axios.get(this.$api_url + '/approver/settings/1').then(response => {
        this.fdata = response.data;
      });
    },
    setSettings(){
      let formData = new FormData();
      for(let [k,v] of Object.entries(this.fdata)) {
        formData.append(k, v);
      }
      axios.post(this.$api_url + '/approver/settings/1', formData).then(response => {
        this.$bvToast.toast('Settings saved successfully',{
          solid: true,
          title: 'Saved',
          variant: 'success',
        })
      });
    },
  },
  created(){
    this.getSettings();
  }
}
</script>
